import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Collapse,
  Input,
  Card,
  Form,
  Select,
  Button,
  Cascader,
} from "antd";
import TripleToggle from "../../../components/trippleToggle/trippleToggle";
import {
  PlusOutlined,
  MinusOutlined,
} from "@ant-design/icons";
import SunEditor from 'suneditor-react';
import {
  align,
  font,
  fontColor,
  fontSize,
  formatBlock,
  hiliteColor,
  horizontalRule,
  lineHeight,
  list,
  paragraphStyle,
  table,
  template,
  textStyle,
  image,
  link

} from "suneditor/src/plugins";
import axios from "axios";
import { MEDIA_UPLOAD_URL } from "../../../Helper";
const { TextArea } = Input;
const options = [
  {
    value: "sq/ft",
    label: "sq/ft",
  },
  {
    value: "sq/yds",
    label: "sq/yds",
  },
  {
    value: "Sqm",
    label: "Sqm",
  },
  {
    value: "boxes",
    label: "boxes",
  },
];
const { Option } = Select;
const { Panel } = Collapse;

const ThirdStep = (props) => {
  console.warn("ThirdStep", props);
  const [form] = Form.useForm();
  const [physicalDes, setphysicalDes] = useState("");
  const [initialValues, setInitialValues] = useState({});
  const [currentValues, setCurrentValues] = useState({});
  
      useEffect(() => {
        if (props.values) {
          setInitialValues(props.values);
        }
      }, [props.values]);
  
      useEffect(() => {
        if (props.values) {
          setCurrentValues(props.values);
        }
      },[]);
  
    const getFieldBgColor = (fieldName) => {
       if (props.editMode) {
        return '#ffffff'; // Always white in edit mode
      }
      const initial = initialValues[fieldName];
      const current = currentValues[fieldName];
  
      if (initial && initial===current) {
        return '#f0f0f0'; // grey if prefilled and unchanged
      }
      return '#ffffff'; // white otherwise
    };

  const SunEditorOpts = {
    showPathLabel: false,
    imageMultipleFile: true,
    imageWidth: "150px",
    imageHeight: "150px",
    height: "auto",
    minHeight: "200px",
    requestHeaders: {
      "X-Sample": "sample",
    },
    plugins: [
      align,
      font,
      fontColor,
      fontSize,
      formatBlock,
      hiliteColor,
      horizontalRule,
      lineHeight,
      list,
      paragraphStyle,
      table,
      template,
      textStyle,
      image,
      link,
    ],
    buttonList: [
      ["undo", "redo"],
      ["font", "fontSize", "formatBlock"],
      ["paragraphStyle"],
      ["bold", "underline", "italic", "strike", "subscript", "superscript"],
      ["fontColor", "hiliteColor"],
      ["removeFormat"],
      ["align", "horizontalRule", "lineHeight"],
      ["outdent", "indent"], ["list"],
      ["table", "link", "image"],
      ["fullScreen", "showBlocks", "preview"],
    ],
    formats: ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6"],
    font: [
      "Arial",
      "Calibri",
      "Comic Sans",
      "Courier",
      "Garamond",
      "Georgia",
      "Impact",
      "Lucida Console",
      "Palatino Linotype",
      "Segoe UI",
      "Tahoma",
      "Times New Roman",
      "Trebuchet MS",
      "Roboto",
    ],
  };

  const onImageUploadBefore = (files, info, uploadHandler) => {
    const formData = new FormData()
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
      },
    };
    formData.append('file', files[0])
    axios.post(MEDIA_UPLOAD_URL, formData, config)
      .then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.data.source_url,
              "name": files[0].name,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response)
      })
  }
  const physicalDesChange = (editorData) => {
    setphysicalDes(editorData);
    props.values.physical_des = editorData;
    props.handleEditor(editorData, "physical_des");
  };
    useEffect(() => {
      props.values.physical_des
        ? setphysicalDes(props.values.physical_des)
        : setphysicalDes("");
    }, []);
  return (
    <Form name="report" autoComplete="off" layout="vertical" form={form}>
      <Card className="reportCard">
        <div className="reportCardBody">
          <div className="formSection">
            <div className="inspectionSection">
              <div className="CollapseSection">
                <Collapse
                  defaultActiveKey={
                    props.values.stepThreeTogg
                      ? props.values.stepThreeTogg
                      : ["1", "2", "3", "4"]
                  }
                  onChange={props.handleChange("stepThreeTogg")}
                  className="reportCollapse"
                  expandIcon={({ isActive }) =>
                    isActive ? (
                      <MinusOutlined className="custom-icon" />
                    ) : (
                      <PlusOutlined className="custom-icon" />
                    )
                  }
                  ghost
                >
                 <Panel header="Concerns" key="1">
                    <div className="inspecContent">
                      <Row gutter={16}>
                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup">
                            <Form.Item label="Condition of Existing Floor" name="concern_con_exi_flr">
                              <Select
                                defaultValue={props.values.concern_con_exi_flr || "Condition of Existing Floor"}
                                onChange={props.handleChange("concern_con_exi_flr")}
                                style={{ backgroundColor: getFieldBgColor("concern_con_exi_flr") }}
                              >
                                <Option value="General Throughout">General Throughout</Option>
                                <Option value="Localized ">Localized </Option>
                                <Option value="Improving">Improving</Option>
                                <Option value="Stabilized">Stabilized</Option>
                                <Option value="Progressing">Progressing</Option>
                                <Option value="Other">Other</Option>
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>

                        {(props.isOpen.concern_con_exi_flrField === true || props.values.concern_con_exi_flr === "Other") && (
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item label="Other" name="concern_con_exi_flr_other">
                                <Input
                                  placeholder="Other"
                                  className="formControl"
                                  onChange={props.handleChange("concern_con_exi_flr_other")}
                                  style={{ backgroundColor: getFieldBgColor("concern_con_exi_flr_other") }}
                                  defaultValue={props.values.concern_con_exi_flr_other}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        )}

                        <Col xs={24} md={24}>
                          <div className="m-2 formGroup">
                            <label>Physical description</label>
                          </div>
                        </Col>

                        <Col xs={24} md={24} xl={24}>
                          <div className="formGroup">
                            <div className="text-editor-wrapper">
                              <SunEditor
                                setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                setOptions={SunEditorOpts}
                                onImageUploadBefore={onImageUploadBefore}
                                setContents={physicalDes}
                                onChange={physicalDesChange}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Panel>

                  <Panel header="Flooring" key="2">
                    <div className="inspecContent">
                      <Row gutter={16}>
                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup">
                            <Form.Item label="Species" name="concern_spec_drop">
                              <Input
                                placeholder="Species"
                                className="formControl"
                                onChange={props.handleChange("concern_spec_drop")}
                                style={{ backgroundColor: getFieldBgColor("concern_spec_drop") }}
                                defaultValue={props.values.concern_spec_drop}
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup">
                            <Form.Item label="Flooring Type" name="flooringtype">
                              <Select
                                defaultValue={props.values.flooringtype || "Flooring Type"}
                                onChange={props.handleChange("flooringtype")}
                                style={{ backgroundColor: getFieldBgColor("flooringtype") }}
                              >
                                <Option value="Factory Finished">Factory Finished</Option>
                                <Option value="Unfinished ">Unfinished </Option>
                                <Option value="Solid">Solid</Option>
                                <Option value="Engineered">Engineered</Option>
                                <Option value="Strip">Strip</Option>
                                <Option value="Plank">Plank</Option>
                                <Option value="Other">Other</Option>
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>

                        {(props.isOpen.concern_spec_drop_otherField === true || props.values.flooringtype === "Other") && (
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item label="Other" name="concern_spec_drop_other">
                                <Input
                                  placeholder="Other"
                                  className="formControl"
                                  onChange={props.handleChange("concern_spec_drop_other")}
                                  style={{ backgroundColor: getFieldBgColor("concern_spec_drop_other") }}
                                  defaultValue={props.values.concern_spec_drop_other}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        )}

                        {(props.isOpen.concern_spec_dropField === true || props.values.flooringtype === "Plank") && (
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item label="Width of Plank" name="concern_spec_drop_width">
                                <Input
                                  placeholder="Width of Plank"
                                  className="formControl"
                                  onChange={props.handleChange("concern_spec_drop_width")}
                                  style={{ backgroundColor: getFieldBgColor("concern_spec_drop_width") }}
                                  defaultValue={props.values.concern_spec_drop_width}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        )}

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup">
                            <Form.Item label="Previously Finished Floor" name="pre_fini_floor">
                              <Select
                                defaultValue={props.values.pre_fini_floor || "Previously Finished Floor"}
                                onChange={props.handleChange("pre_fini_floor")}
                                style={{ backgroundColor: getFieldBgColor("pre_fini_floor") }}
                              >
                                <Option value="Previously Finished Floor ">Previously Finished Floor </Option>
                                <Option value="Factory Finished">Factory Finished</Option>
                                <Option value="New Install">New Install</Option>
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup">
                            <Form.Item label="Type of Finish on Existing Floor" name="type_of_finish_exis_flr">
                              <Input
                                placeholder="Type of Finish on Existing Floor"
                                className="formControl"
                                onChange={props.handleChange("type_of_finish_exis_flr")}
                                style={{ backgroundColor: getFieldBgColor("type_of_finish_exis_flr") }}
                                defaultValue={props.values.type_of_finish_exis_flr}
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Total Sq/ft" name="totalsqft_per_cont">
                              <Input
                                className="formGroup customPadding"
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type15")}
                                    options={options}
                                    defaultValue={props.values.measure_type15}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("totalsqft_per_cont")}
                                style={{ backgroundColor: getFieldBgColor("totalsqft_per_cont") }}
                                defaultValue={props.values.totalsqft_per_cont}
                                placeholder="Total Sq/ft"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup">
                            <Form.Item label="% of Floor Affected" name="per_flo_aff">
                              <Input
                                placeholder="% of Floor Affected"
                                className="formControl"
                                onChange={props.handleChange("per_flo_aff")}
                                style={{ backgroundColor: getFieldBgColor("per_flo_aff") }}
                                defaultValue={props.values.per_flo_aff}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Panel>

                  <Panel header="Rooms Being Inspected" key="3">
                    <div className="inspecContent">
                      <Row gutter={16}>
                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Entry" name="rooms_entry">
                              <Input
                                className="formGroup customPadding"
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type1")}
                                    options={options}
                                    defaultValue={props.values.measure_type1}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("rooms_entry")}
                                style={{ backgroundColor: getFieldBgColor("rooms_entry") }}
                                defaultValue={props.values.rooms_entry}
                                placeholder="Entry"
                              />
                            </Form.Item>
                          </div>
                        </Col>


                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Formal" name="rooms_formal">
                              <Input
                                className="formGroup customPadding"
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("formal_temp")}
                                    options={options}
                                    defaultValue={props.values.formal_temp}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("rooms_formal")}
                                style={{ backgroundColor: getFieldBgColor("rooms_formal") }}
                                defaultValue={props.values.rooms_formal}
                                placeholder="Formal"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Kitchen" name="rooms_kit">
                              <Input
                                className="formGroup customPadding"
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type3")}
                                    options={options}
                                    defaultValue={props.values.measure_type3}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("rooms_kit")}
                                style={{ backgroundColor: getFieldBgColor("rooms_kit") }}
                                defaultValue={props.values.rooms_kit}
                                placeholder="Kitchen"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Study" name="rooms_study">
                              <Input
                                className="formGroup customPadding"
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type4")}
                                    options={options}
                                    defaultValue={props.values.measure_type4}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("rooms_study")}
                                style={{ backgroundColor: getFieldBgColor("rooms_study") }}
                                defaultValue={props.values.rooms_study}
                                placeholder="Study"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Hall(s)" name="rooms_hall">
                              <Input
                                className="formGroup customPadding"
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type5")}
                                    options={options}
                                    defaultValue={props.values.measure_type5}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("rooms_hall")}
                                style={{ backgroundColor: getFieldBgColor("rooms_hall") }}
                                defaultValue={props.values.rooms_hall}
                                placeholder="Hall(s)"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Library" name="rooms_library">
                              <Input
                                className="formGroup customPadding"
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type6")}
                                    options={options}
                                    defaultValue={props.values.measure_type6}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("rooms_library")}
                                style={{ backgroundColor: getFieldBgColor("rooms_library") }}
                                defaultValue={props.values.rooms_library}
                                placeholder="Library"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Great Room" name="rooms_great_room">
                              <Input
                                className="formGroup customPadding"
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type7")}
                                    options={options}
                                    defaultValue={props.values.measure_type7}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("rooms_great_room")}
                                style={{ backgroundColor: getFieldBgColor("rooms_great_room") }}
                                defaultValue={props.values.rooms_great_room}
                                placeholder="Great Room"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Living Room" name="rooms_living_room">
                              <Input
                                className="formGroup customPadding"
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type9")}
                                    options={options}
                                    defaultValue={props.values.measure_type9}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("rooms_living_room")}
                                style={{ backgroundColor: getFieldBgColor("rooms_living_room") }}
                                defaultValue={props.values.rooms_living_room}
                                placeholder="Living Room"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Dining Room" name="rooms_dining_roo">
                              <Input
                                className="formGroup customPadding"
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type10")}
                                    options={options}
                                    defaultValue={props.values.measure_type10}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("rooms_dining_roo")}
                                style={{ backgroundColor: getFieldBgColor("rooms_dining_roo") }}
                                defaultValue={props.values.rooms_dining_roo}
                                placeholder="Dining Room"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Nook" name="rooms_nook">
                              <Input
                                className="formGroup customPadding"
                                style={{ backgroundColor: getFieldBgColor("rooms_nook") }}
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type11")}
                                    options={options}
                                    defaultValue={props.values.measure_type11}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("rooms_nook")}
                                defaultValue={props.values.rooms_nook}
                                placeholder="Nook"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Pantry" name="rooms_part">
                              <Input
                                className="formGroup customPadding"
                                style={{ backgroundColor: getFieldBgColor("rooms_part") }}
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type12")}
                                    options={options}
                                    defaultValue={props.values.measure_type12}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("rooms_part")}
                                defaultValue={props.values.rooms_part}
                                placeholder="Pantry"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Powder Bath" name="powderBath">
                              <Input
                                className="formGroup customPadding"
                                style={{ backgroundColor: getFieldBgColor("powderBath") }}
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type13")}
                                    options={options}
                                    defaultValue={props.values.measure_type13}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("powderBath")}
                                defaultValue={props.values.powderBath}
                                placeholder="Powder Bath"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6} className="appendDiv formGroup">
                          <label htmlFor="Bath" className="pb-2">Bath</label>
                          {props.bathArea.map((singleBatharea, index) => (
                            <div key={index} className="services mb-2">
                              <div className="first-division">
                                <Input.Group compact>
                                  <div className="input-group customRepeatorDivHide">
                                    <Input
                                      name="bath_area"
                                      type="text"
                                      id="bath_area"
                                      value={singleBatharea.bath_area}
                                      style={{ backgroundColor: getFieldBgColor("bath_area") }}
                                      onChange={(e) => props.handleBathChange(e, index, 'bath_area')}
                                      placeholder="Bath"
                                      className="formControl customPaddingg"
                                    />
                                    <Select
                                      name="bath_area_unit"
                                      defaultValue={singleBatharea.bath_area_unit}
                                      options={options}
                                      onChange={(e) => props.handleBathChange(e, index, 'bath_area_unit')}
                                      className="customselect"
                                    />
                                  </div>
                                  {props.bathArea.length - 1 === index && props.bathArea.length < 5 && (
                                    <Button
                                      type="button"
                                      onClick={props.handleBathAdd}
                                      className="formControl repeatorDivHideBtn"
                                      icon={<PlusOutlined />}
                                    />
                                  )}
                                  {props.bathArea.length !== 1 && (
                                    <Button
                                      type="button"
                                      icon={<MinusOutlined />}
                                      onClick={() => props.handleBathRemove(index)}
                                      className="formControl repeatorDivHideBtn"
                                    />
                                  )}
                                </Input.Group>
                              </div>
                            </div>
                          ))}
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup custom-form-group">
                            <Form.Item label="Master Bedroom" name="masterbedroom">
                              <Input
                                className="formGroup customPadding"
                                style={{ backgroundColor: getFieldBgColor("masterbedroom") }}
                                addonAfter={
                                  <Cascader
                                    placeholder="sq/ft"
                                    onChange={props.handleChange("measure_type14")}
                                    options={options}
                                    defaultValue={props.values.measure_type14}
                                    className="custom-cascadar"
                                  />
                                }
                                onChange={props.handleChange("masterbedroom")}
                                defaultValue={props.values.masterbedroom}
                                placeholder="Master Bedroom"
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col xs={24} md={6} xl={6} className="appendDiv formGroup">
                          <label htmlFor="gc_subdivision" className="pb-2 formGroup">Bed</label>
                          {props.masterBedroomArea.map((singleMasterarea, index) => (
                            <div key={index} className="services mb-2">
                              <div className="first-division">
                                <Input.Group compact>
                                  <div className="input-group customRepeatorDivHide">
                                    <Input
                                      name="master_bedroom_area"
                                      type="text"
                                      id="master_bedroom_area"
                                      value={singleMasterarea.master_bedroom_area}
                                      style={{ backgroundColor: getFieldBgColor("master_bedroom_area") }}
                                      onChange={(e) => props.handleMasterChange(e, index, 'master_bedroom_area')}
                                      placeholder="Bed"
                                      className="formControl customPaddingg"
                                    />
                                    <Select
                                      name="master_bedroom_area_unit"
                                      defaultValue={singleMasterarea.master_bedroom_area_unit}
                                      options={options}
                                      onChange={(e) => props.handleMasterChange(e, index, 'master_bedroom_area_unit')}
                                      className="customselect"
                                    />
                                  </div>
                                  {props.masterBedroomArea.length - 1 === index && props.masterBedroomArea.length < 5 && (
                                    <Button
                                      type="button"
                                      onClick={props.handleMasterAdd}
                                      className="formControl repeatorDivHideBtn"
                                      icon={<PlusOutlined />}
                                    />
                                  )}
                                  {props.masterBedroomArea.length !== 1 && (
                                    <Button
                                      type="button"
                                      icon={<MinusOutlined />}
                                      onClick={() => props.handleMasterRemove(index)}
                                      className="formControl repeatorDivHideBtn"
                                    />
                                  )}
                                </Input.Group>
                              </div>
                            </div>
                          ))}
                        </Col>

                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup">
                            <Form.Item label="Other Rooms" name="other_rooms">
                              <Input
                                placeholder="Other Rooms"
                                className="formControl"
                                style={{ backgroundColor: getFieldBgColor("other_rooms") }}
                                onChange={props.handleChange("other_rooms")}
                                defaultValue={props.values.other_rooms}
                              />
                            </Form.Item>
                          </div>
                        </Col>


                        <Col xs={24} md={6} xl={6}>
                        <div className="formGroup">
                          <Form.Item label="Airflow Obstacles" name="airFlow_obstacles">
                            <Input
                              placeholder="Airflow Obstacles"
                              className="formControl"
                              style={{ backgroundColor: getFieldBgColor("airFlow_obstacles") }}
                              onChange={props.handleChange("airFlow_obstacles")}
                              defaultValue={props.values.airFlow_obstacles}
                            />
                          </Form.Item>
                        </div>
                      </Col>

                      {props.isOpen.heatingField === true || props.values.heating_system === "Other" ? (
                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup">
                            <Form.Item label="Other(Type)" name="heating_system_other">
                              <Input
                                placeholder="Other(Type)"
                                className="formControl"
                                style={{ backgroundColor: getFieldBgColor("heating_system_other") }}
                                onChange={props.handleChange("heating_system_other")}
                                defaultValue={props.values.heating_system_other}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      ) : null}

                      {props.isOpen.acField === true || props.values.type_cooling_sys === "Other" ? (
                        <Col xs={24} md={6} xl={6}>
                          <div className="formGroup">
                            <Form.Item label="Other(Type)" name="air_on_other">
                              <Input
                                placeholder="Other(Type)"
                                className="formControl"
                                style={{ backgroundColor: getFieldBgColor("air_on_other") }}
                                onChange={props.handleChange("air_on_other")}
                                defaultValue={props.values.air_on_other}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      ) : null}

                      <Col xs={24} md={24} xl={24}>
                        <div className="formGroup">
                          <Form.Item
                            label="Other Trades | Schedules Prior to, During or After Installation"
                            name="other_trades"
                          >
                            <TextArea
                              placeholder="Other Trades | Schedules Prior to, During or After Installation"
                              className="formControl"
                              style={{ backgroundColor: getFieldBgColor("other_trades") }}
                              onChange={props.handleChange("other_trades")}
                              defaultValue={props.values.other_trades}
                            />
                          </Form.Item>
                        </div>
                      </Col>

                      <Col xs={24} md={24} xl={24}>
                        <div className="formGroup">
                          <Form.Item
                            label="Any Special or Unique Use"
                            name="any_special_or_unique_use"
                          >
                            <TextArea
                              placeholder="Any Special or Unique Use"
                              className="formControl"
                              style={{ backgroundColor: getFieldBgColor("any_special_or_unique_use") }}
                              onChange={props.handleChange("any_special_or_unique_use")}
                              defaultValue={props.values.any_special_or_unique_use}
                            />
                          </Form.Item>
                        </div>
                      </Col>

                      <Col xs={24} md={24} xl={24}>
                        <div className="formGroup">
                          <Form.Item
                            label="Summary of Physical Description"
                            name="summ_phy_descri"
                          >
                            <TextArea
                              placeholder="Summary of Physical Description"
                              className="formControl"
                              style={{ backgroundColor: getFieldBgColor("summ_phy_descri") }}
                              onChange={props.handleChange("summ_phy_descri")}
                              defaultValue={props.values.summ_phy_descri}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      </Row>
                    </div>
                  </Panel>
                </Collapse>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </Form>
  );
};

export default ThirdStep;
